export default __webpack_public_path__ + "static/vankooten-67aa9c4409967cbeb91248545f7c5aa3.jpg";